import { notification } from '@/plugins/helpers'
import { AlertTypes } from '../plugins/alerts_types'

export default {
  data () {
    return {
      dialogEmailOpen: false,
      showEmailConfirmation: false,
      emailConfirmation: ''
    }
  },
  methods: {
    onEmailInput () {
      if (this.pedido.cliente.email.length > 0) {
        this.showEmailConfirmation = true
      } else {
        this.showEmailConfirmation = false
        this.emailConfirmation = ''
      }
    },
    emailsMatch () {
      return this.pedido.cliente.email === this.emailConfirmation || 'Os e-mails não correspondem'
    },
    openDialogConfirm () {
      if (this.$refs.form.validateField('FieldEmail')) {
        this.dialogEmailOpen = true
      }
    },
    openDialog () {
      const form = this.$refs.form

      if (this.showEmailConfirmation && this.emailConfirmation.length > 0 && this.pedido.cliente.email !== this.emailConfirmation) {
        notification(AlertTypes.WARN, 'Os e-mails não correspondem. Por favor, verifique e tente novamente.')
        return
      }

      if (!this.validarEmail(this.pedido.cliente.email)) {
        notification(
          AlertTypes.ERROR,
          'Foi identificado um erro de digitação no e-mail informado para o seu cliente. Por favor, revise e corrija-o antes de tentar novamente! Caso o erro persistir, entre em contato com a Área de Suporte.'
        )
        return
      }

      if (form.validate()) {
        this.openEmailDialog()
      }
    },
    openEmailDialog () {
      this.dialogEmailOpen = true
    },
    focus () {
      this.dialogEmailOpen = false
      this.$nextTick(() => {
        this.pedido.cliente.email = ''
        const emailInput = this.$refs.emailField.$el.querySelector('input')
        if (emailInput) {
          emailInput.focus()
        } else {
          console.error('Campo de e-mail não encontrado.')
        }
      })
    },
    handleEmailConfirmed (email) {
      this.pedido.cliente.email = email

      if (!this.validarEmail(email)) {
        notification(
          AlertTypes.ERROR,
          'Foi identificado um erro de digitação no e-mail informado para o seu cliente. Por favor, revise e corrija-o antes de tentar novamente! Caso o erro persistir, entre em contato com a Área de Suporte.'
        )
        this.dialogEmailOpen = true
        return
      }

      this.next()
    },
    validarEmail (email) {
      const regex = /\S+@\S+\.\S+/
      return regex.test(email)
    },
    getEmail (instanciaCliente, cliente) {
      return (instanciaCliente && instanciaCliente.email) || (cliente && cliente.email) || '-'
    }
  }
}
